import type { RouteObject } from 'react-router-dom';
import { PERMISSIONS } from '@shared/constants/permissions';
import { lazyPage } from '@shared/router/lazy-page';
import { PATHS } from '@/router/paths';

/**
 * Integrations. Each screen carries the key its endpoints check: TeamLogger
 * reads need `teamlogger.view`; the project-mapping and manual-review screens
 * are the `/project-mappings` resource (`project-mappings.view`); Asana task lookups
 * need `asana.view`. Hiding a sidebar link is never the protection.
 */
export const integrationsRoutes: RouteObject[] = [
  lazyPage(
    PATHS.app.teamLogger,
    async () => (await import('./teamlogger/teamlogger-page')).TeamLoggerPage,
    { permission: PERMISSIONS.teamlogger.view },
  ),
  lazyPage(
    PATHS.app.projectMappings,
    async () => (await import('./project-mappings/project-mappings-page')).ProjectMappingsPage,
    { permission: PERMISSIONS.projectMappings.view },
  ),
  lazyPage(
    PATHS.app.teamLoggerManualReview,
    async () => (await import('./teamlogger/manual-review')).ManualReviewPage,
    { permission: PERMISSIONS.projectMappings.view },
  ),
  lazyPage(PATHS.app.asana, async () => (await import('./asana/asana-page')).AsanaPage, {
    permission: PERMISSIONS.asana.view,
  }),
];
